export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-2.png?5189a2dd4842bb72e8b01ea4bd86b2ed";